import { localeConfig as af } from './config/af';
import { localeConfig as ar } from './config/ar';
import { localeConfig as az } from './config/az';
import { localeConfig as bg } from './config/bg';
import { localeConfig as bn } from './config/bn';
import { localeConfig as ca } from './config/ca';
import { localeConfig as ceb } from './config/ceb';
import { localeConfig as cs } from './config/cs';
import { localeConfig as da } from './config/da';
import { localeConfig as de } from './config/de';
import { localeConfig as el } from './config/el';
import { localeConfig as enGB } from './config/en-GB';
import { localeConfig as en } from './config/en';
import { localeConfig as es419 } from './config/es-419';
import { localeConfig as es } from './config/es';
import { localeConfig as et } from './config/et';
import { localeConfig as fa } from './config/fa';
import { localeConfig as fi } from './config/fi';
import { localeConfig as fil } from './config/fil';
import { localeConfig as frCA } from './config/fr-CA';
import { localeConfig as fr } from './config/fr';
import { localeConfig as ga } from './config/ga';
import { localeConfig as gu } from './config/gu';
import { localeConfig as he } from './config/he';
import { localeConfig as hi } from './config/hi';
import { localeConfig as hr } from './config/hr';
import { localeConfig as hu } from './config/hu';
import { localeConfig as id } from './config/id';
import { localeConfig as is } from './config/is';
import { localeConfig as it } from './config/it';
import { localeConfig as ja } from './config/ja';
import { localeConfig as jv } from './config/jv';
import { localeConfig as kk } from './config/kk';
import { localeConfig as km } from './config/km';
import { localeConfig as kn } from './config/kn';
import { localeConfig as ko } from './config/ko';
import { localeConfig as lt } from './config/lt';
import { localeConfig as lv } from './config/lv';
import { localeConfig as ml } from './config/ml';
import { localeConfig as mr } from './config/mr';
import { localeConfig as ms } from './config/ms';
import { localeConfig as my } from './config/my';
import { localeConfig as nb } from './config/nb';
import { localeConfig as nl } from './config/nl';
import { localeConfig as or } from './config/or';
import { localeConfig as pa } from './config/pa';
import { localeConfig as pl } from './config/pl';
import { localeConfig as ptBR } from './config/pt-BR';
import { localeConfig as ptPT } from './config/pt-PT';
import { localeConfig as pt } from './config/pt';
import { localeConfig as ro } from './config/ro';
import { localeConfig as ru } from './config/ru';
import { localeConfig as sk } from './config/sk';
import { localeConfig as sl } from './config/sl';
import { localeConfig as sq } from './config/sq';
import { localeConfig as sv } from './config/sv';
import { localeConfig as sw } from './config/sw';
import { localeConfig as ta } from './config/ta';
import { localeConfig as te } from './config/te';
import { localeConfig as th } from './config/th';
import { localeConfig as tr } from './config/tr';
import { localeConfig as uk } from './config/uk';
import { localeConfig as ur } from './config/ur';
import { localeConfig as uz } from './config/uz';
import { localeConfig as vi } from './config/vi';
import { localeConfig as zhHans } from './config/zh-Hans';
import { localeConfig as zhHant } from './config/zh-Hant';
export const localeConfig = {
  af,
  ar,
  az,
  bg,
  bn,
  ca,
  ceb,
  cs,
  da,
  de,
  el,
  'en-GB': enGB,
  en,
  'es-419': es419,
  es,
  et,
  fa,
  fi,
  fil,
  'fr-CA': frCA,
  fr,
  ga,
  gu,
  he,
  hi,
  hr,
  hu,
  id,
  is,
  it,
  ja,
  jv,
  kk,
  km,
  kn,
  ko,
  lt,
  lv,
  ml,
  mr,
  ms,
  my,
  nb,
  nl,
  or,
  pa,
  pl,
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  pt,
  ro,
  ru,
  sk,
  sl,
  sq,
  sv,
  sw,
  ta,
  te,
  th,
  tr,
  uk,
  ur,
  uz,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
